import { AfterViewInit, Component, inject, OnDestroy } from '@angular/core';

import { Viewport } from '../../../../swagger-api';
import { FormFieldSate } from '../form-field.state';
import { ViewportService } from './viewport-service.service';

@Component({
  selector: 'app-viewport-form-field',
  template: '',
})
export class ViewportFormFieldComponent extends FormFieldSate implements AfterViewInit, OnDestroy {
  private viewportService = inject(ViewportService);

  public ngAfterViewInit(): void {
    this.subscriptions.push(
      this.viewportService.viewportUpdated.subscribe((viewport: Viewport) => {
        this.control.patchValue(viewport);
      }),
    );
  }
}
